/**
 * @generated SignedSource<<8893566f20599883f2a95f26af6a6b71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleHistoryMasterList_team$data = {
  readonly id: string;
  readonly teamSchedules: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleHistoryMasterListItem_teamSchedule">;
      };
    }>;
  };
  readonly " $fragmentType": "TeamScheduleHistoryMasterList_team";
};
export type TeamScheduleHistoryMasterList_team$key = {
  readonly " $data"?: TeamScheduleHistoryMasterList_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleHistoryMasterList_team">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "teamSchedules"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "freq"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./TeamScheduleHistoryScreen_teamRefetch.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "TeamScheduleHistoryMasterList_team",
  "selections": [
    {
      "alias": "teamSchedules",
      "args": [
        {
          "kind": "Variable",
          "name": "freq",
          "variableName": "freq"
        }
      ],
      "concreteType": "TeamScheduleConnection",
      "kind": "LinkedField",
      "name": "__TeamScheduleHistoryScreen__teamSchedules_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamScheduleEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamSchedule",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TeamScheduleHistoryMasterListItem_teamSchedule"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "58d5bef137eaa357629c8c89aecf93cc";

export default node;
